<template>
  <div class="CheckInRecord">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="入住名称">
        <el-input v-model="searchForm.tenantName"
                  placeholder="入住名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
    </el-form>
    <el-table class="dataTable"
              v-loading="dataListLoading"
              :data="dataList"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              border>
      <el-table-column label="入住名称"
                       prop="tenantName">
      </el-table-column>
      <el-table-column label="入住地址"
                       prop="address">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="openDetailDialog(scope.row.id)">查看</el-button>
          <!-- <el-button size="mini"
                     type="danger"
                     @click="handleDelete(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="pageIndex"
                   :page-size="pageSize"
                   :page-sizes="[10, 20, 50, 100]"
                   :total="totalPage"
                   background
                   layout="total, sizes, prev, pager, next, jumper"
                   @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle">
    </el-pagination>

    <!-- 入住信息详情 -->
    <el-dialog title="入住信息详情"
               :visible.sync="detailDialog"
               width="40%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="入住名称："
                      prop="tenantName">
          <span>{{ detailForm.apartmentName}}</span>
        </el-form-item>
        <el-form-item label="入住地址："
                      prop="address">
          <span>{{ detailForm.address}}</span>
        </el-form-item>
        <el-form-item label="创建时间："
                      prop="createdTime">
          <span>{{ detailForm.createdTime}}</span>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/CheckInRecord.css'
export default {
  data() {
    return {
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 1,
      detailDialog: false,
      detailForm: {},
    }
  },

  computed: {},

  created() {
    let self = this

    self.getDataList()
  },

  mounted() {},

  methods: {
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取数据列表
    getDataList(type) {
      let self = this

      if (type == 'search') {
        self.pageIndex = 1
      }

      self.dataListLoading = true

      let tenantName = self.searchForm.tenantName

      let formdata = new FormData()

      formdata.append('tenantName', tenantName)

      self.$axios
        ._getApartmentlist(formdata)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.dataList = datas.data
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 1
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 入住信息弹窗
    openDetailDialog: function (id) {
      let self = this

      let str = {
        tenantId: id,
      }

      if (code) {
        self.$axios
          ._getApartmentInfo(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.detailForm = datas.data
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      self.detailDialog = true
    },

    // 关闭 入住信息弹窗
    cancelDetailDialog: function () {
      let self = this

      Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除入住记录
    handleDelete(row) {
      let self = this

      self
        .$confirm(`是否确认要删除 "${row.tenantName}" 入住？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delApartment(row.id)
        })
        .then((data) => {})
    },

    delApartment(code) {
      let self = this

      self.$axios
        ._deleteApartment(code)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>


// WEBPACK FOOTER //
// src/views/CheckInRecord.vue